import {View} from 'react-native'
import {msg, Trans} from '@lingui/macro'
import {useLingui} from '@lingui/react'

import {type MatrixRoomSummary} from '#/state/matrix/utils'
import {useProfileQuery} from '#/state/queries/profile'
import {UserAvatar} from '#/view/com/util/UserAvatar'
import {atoms as a, useTheme} from '#/alf'
import {ButtonIcon, ButtonText} from '#/components/Button'
import {ArrowRight_Stroke2_Corner0_Rounded as ArrowRightIcon} from '#/components/icons/Arrow'
import {Envelope_Stroke2_Corner2_Rounded as EnvelopeIcon} from '#/components/icons/Envelope'
import {Link} from '#/components/Link'

function RequestAvatars({requests}: {requests: MatrixRoomSummary[]}) {
  const dids = requests.slice(0, 3).map(r => r.otherMemberDids[0])
  return (
    <View style={[a.flex_row, {marginRight: -4}]}>
      {dids.map(
        (did, i) => did && <RequestAvatar key={did} did={did} index={i} />,
      )}
    </View>
  )
}

function RequestAvatar({did, index}: {did: string; index: number}) {
  const t = useTheme()
  const {data: profile} = useProfileQuery({did})
  return (
    <View
      style={[
        a.rounded_full,
        {
          marginLeft: index > 0 ? -8 : 0,
          borderWidth: 2,
          borderColor: t.atoms.bg.backgroundColor,
        },
      ]}>
      <UserAvatar type="user" size={24} avatar={profile?.avatar} />
    </View>
  )
}

export function SecureInboxPreview({
  requests,
}: {
  requests: MatrixRoomSummary[]
}) {
  const {_} = useLingui()
  const t = useTheme()
  return (
    <Link
      label={_(msg`Secure chat request inbox`)}
      style={[
        a.px_xl,
        a.py_sm,
        a.flex_row,
        a.align_center,
        a.gap_md,
        a.border_t,
        {marginTop: a.border_t.borderTopWidth * -1},
        a.border_b,
        t.atoms.border_contrast_low,
        {minHeight: 44},
        a.rounded_0,
      ]}
      to="/messages/secure-inbox"
      color="secondary"
      variant="solid">
      <View style={[a.relative]}>
        <ButtonIcon icon={EnvelopeIcon} size="lg" />
        {requests.length > 0 && (
          <View
            style={[
              a.absolute,
              a.rounded_full,
              a.z_20,
              {
                top: -4,
                right: -5,
                width: 10,
                height: 10,
                backgroundColor: t.palette.primary_500,
              },
            ]}
          />
        )}
      </View>
      <ButtonText
        style={[a.flex_1, a.font_bold, a.text_left]}
        numberOfLines={1}>
        <Trans>Chat requests</Trans>
      </ButtonText>
      <RequestAvatars requests={requests} />
      <ButtonIcon icon={ArrowRightIcon} size="lg" />
    </Link>
  )
}
